<template>
     <div class="conf-con">
                            <div class="intro-pic">
                              <img src="../../../assets/images/03.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第三次全国代表大会简介</p>
                            <p class="margin1">１９２３年６月１２日至２０日，中国共产党第三次全国代表大会在广州东山恤孤院３１号（现恤孤院路３号）召开。陈独秀、李大钊、毛泽东、蔡和森、陈潭秋、恽代英、瞿秋白、张国焘、李立三、项英等来自全国各地及莫斯科的代表近４０人出席大会，他们代表了全国４２０名党员。共产国际代表马林参加了会议。陈独秀主持会议并代表第二届中央执行委员会作报告。</p>
                            <p class="margin1">大会的主要议程有三项：一、讨论党纲草案；二、讨论同国民党建立革命统一战线问题；三、选举党的中央执行委员会。</p>
                            <p class="margin1">会议的中心议题是讨论与国民党合作、建立革命统一战线的问题。陈独秀在报告中，着重说明了中国共产党决定和国民党建立革命统一战线的依据和过程。代表们就共产党员以个人身份加入国民党、建立革命统一战线的问题进行了热烈的讨论。</p>
                            <p class="margin1">经过讨论，大会接受了共产国际关于中国共产党同中国国民党进行合作的指示，通过了《关于国民运动及国民党问题的议决案》、《中国共产党第三次全国代表大会宣言》等文件。这些文件的中心思想是，党在现阶段“应该以国民革命运动为中心工作”，共产党员以个人身份加入国民党，采取党内合作的形式，同国民党建立联合战线，以完成反帝反封建的国民革命的重要任务。文件还规定了要保持中国共产党在政治上的独立性的一些原则。</p>
                            <p class="margin1">大会选举陈独秀、蔡和森、李大钊、谭平山、王荷波、毛泽东、朱少连、项英、罗章龙等９人为中央委员，邓培、张连光、徐梅坤、李汉俊、邓中夏５人为候补中央委员，由陈独秀、蔡和森、毛泽东、罗章龙、谭平山（后由于谭调职，改为王荷波）５人组成中央局，陈独秀为委员长，毛泽东为秘书，罗章龙担任会计，负责中央日常工作。</p>
                            <p class="margin1">党的三大根据马克思列宁主义的策略原则和共产国际的指示，结合中国革命的具体情况，充分发扬民主，在分析中国社会矛盾和明确中国革命性质的基础上，正确解决了建党初期党内在国共合作问题上存在的重大分歧，统一了全党的认识，正式确定了共产党员以个人身份加入国民党，与国民党进行党内合作的策略方针，使党能够团结一切可能联合的力量，共同完成反帝反封建的民主革命任务。</p>
                            <p class="margin1">党的三大之后，在中国共产党的推动下，孙中山先生对国民党进行了改组，确定了联俄、联共、扶助农工的三大政策，召开了国共合作的国民党第一次全国代表大会，第一次国共合作正式建立，全国掀起了声势浩大、轰轰烈烈的反帝反封建的革命群众运动，胜利地举行了北伐战争，促进了中国革命的高涨。但是，大会对于无产阶级领导权问题、农民问题和军队问题没有给以应有的重视。 </p>
                            <p class="margin1">党的三大结束的当天，代表们来到黄花岗烈士墓前，在瞿秋白同志的指挥下高唱国际歌。中国共产党第三次代表大会，就在雄壮有力的国际歌声中胜利闭幕了。</p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>